import React from 'react';

export default function Loader({ text = 'Processing', subtext = 'Please confirm in your wallet' }) {
  return (
    <div className="loader-overlay">
      <div className="loader-candles">
        <div className="candle" />
        <div className="candle" />
        <div className="candle" />
        <div className="candle" />
        <div className="candle" />
      </div>
      <div style={{ textAlign: 'center' }}>
        <div className="loader-text">{text}</div>
        <div className="loader-subtext mt-2">{subtext}</div>
      </div>
    </div>
  );
}
